<template>
   <div class="menuadmin">
        <div class="menu-mobile menu-activated-on-click">
          <div class="menu-and-user">
            <ul class="main-menu">
            <li class="sub-header">
              <span>Perfil Credenciado</span>
            </li>
            <li class="has-sub-menu">
                <router-link :to="{name: 'Dashboard'}">
                    <i class="icon-w fas fa-home"></i><span>Home</span>
                </router-link>

                <router-link :to="{name: 'Empresa'}" v-if="isAdministrador">
                    <i class="icon-w fas fa-industry"></i><span>Empresa</span>
                </router-link>

                <router-link :to="{name: 'EmpresaVendedor'}" v-if="isVendedorMaster || isAdministrador">
                    <i class="icon-w fas fa-industry"></i><span>Vendedores</span>
                </router-link>

                <router-link :to="{name: 'EmpresaPlano'}" v-if="isAdministrador">
                    <i class="icon-w fas fa-file-medical"></i><span>Planos</span>
                </router-link>

                <router-link :to="{name: 'PedidoForm'}">
                    <i class="icon-w fas fa-money-check-alt"></i><span>Novo Pedido</span>
                </router-link>

                <router-link :to="{name: 'ValidarCartao'}">
                    <i class="icon-w fas fas fa-credit-card"></i><span>{{empresa.name}} Card</span>
                </router-link>

                <router-link :to="{name: 'RelatorioPedidos'}">
                    <i class="icon-w fas fas fa-chart-bar"></i><span>Pedidos</span>
                </router-link>

                <router-link :to="{name: 'GerenciarSolicitacoes'}" v-if="isAdministrador">
                    <img class="icon-w fas" style="color: #0073ff;" width="16" src="@/assets/img/atendimento.svg">
                    <span>Solicitações</span>
                </router-link>
            </li>

          </ul>

          </div>
        </div>
        <!--------------------
        END - Mobile Menu
        --------------------><!--------------------
        START - Main Menu
        -------------------->
        <div class="menu-w menu-position-side menu-side-left menu-layout-compact sub-menu-style-over sub-menu-color-bright selected-menu-color-light menu-activated-on-hover menu-has-selected-link">

        <div class="user-intro">
            <div class="avatar">
                <img style="height: 90px !important" :alt="empresa.name" :src="imgEmpresa" :onerror="`this.src='${require('@/assets/img/icon-drachei.svg')}'`" class="rounded-circle img-fluid">
            </div>
            <div class="user-intro-info">
                <h5 class="user-name" style="overflow: hidden;width: 200px">
                    {{empresa.name}}
                </h5>
                <div class="user-sub" v-if="empresa.cidade">
                    {{empresa.cidade}} - {{empresa.uf}}
                </div>
            </div>
        </div>

        <div class="m-2" v-if="isAdministrador">
            <app-list-empresa></app-list-empresa>
        </div>

          <ul class="main-menu border-bottom">
            <li class="sub-header">
              <span>Principal</span>
            </li>
            <li class="">
            <router-link :to="{name: 'Dashboard'}">
                <i class="icon-w fas fa-home"></i><span>Home</span>
            </router-link>

            <router-link :to="{name: 'Empresa'}" v-if="isAdministrador">
                <i class="icon-w fas fa-industry"></i><span>Empresa</span>
            </router-link>

            <router-link :to="{name: 'EmpresaVendedor'}" v-if="isVendedorMaster || isAdministrador">
                <i class="icon-w fas fa-industry"></i><span>Vendedores</span>
            </router-link>

            <router-link :to="{name: 'EmpresaPlano'}" v-if="isAdministrador">
                <i class="icon-w fas fa-file-medical"></i><span>Planos</span>
            </router-link>

            <router-link :to="{name: 'PedidoForm'}">
                <i class="icon-w fas fa-money-check-alt"></i><span>Novo Pedido</span>
            </router-link>

            <router-link :to="{name: 'ValidarCartao'}">
                <i class="icon-w fas fas fa-credit-card"></i><span>{{empresa.name}} Card</span>
            </router-link>

            <router-link :to="{name: 'RelatorioPedidos'}">
                <i class="icon-w fas fas fa-chart-bar"></i><span>Pedidos</span>
            </router-link>

            <router-link :to="{name: 'GerenciarSolicitacoes'}" v-if="isAdministrador">
                <i class="icon-w fas fa-headset"></i>
                <span>Solicitações</span>
            </router-link>

            <router-link :to="{name: 'Financeiro'}" v-if="isAdministrador || isVendedorMaster">
                <i class="icon-w fas fas fa-donate"></i>
                <span>Financeiro</span>
            </router-link>
             <router-link :to="{name: 'envioFaturas'}" v-if="isAdministrador">
               <i class="icon-w fas fas fa-envelope"></i>
                <span>Correio</span>
            </router-link>
            <router-link :to="{name: 'ParceiroList'}" v-if="isAdministrador || isVendedorMaster">
              <i class="icon-w fas fas fa-handshake"></i>
              <span>Parceiros</span>
            </router-link>
              <router-link :to="{name: 'BeneficioList'}" v-if="isAdministrador">
                <i class="icon-w fas fas fa-tags"></i>
                <span>Beneficios</span>
              </router-link>
            </li>
          </ul>

        </div>
   </div>
</template>
<script>
import axios from 'axios';
import ListEmpresa from '@/components/listEmpresa'

export default {
  components: {
    'app-list-empresa': ListEmpresa
  },
  computed: {
    user () {
      return this.$store.getters.user
    },
    menuCredenciado () {
      return this.menuCredenciadoAgendamento
    },
    empresa () {
      return this.$store.getters.empresa || {}
    },
    imgEmpresa () {
      return `${axios.defaults.baseURL}/api/juridica/${this.empresa._id}/img`;
    },
    isAdministrador () {
      return this.$store.getters.isAdministrador;
    },
    isVendedorMaster () {
      return this.$store.getters.isVendedorMaster;
    },
    isVendedor() {
      return this.$store.getters.isVendedor;
    }
  },
  data () {
    return {
      menuCredenciadoSemAgendamento: [
        {icon: 'fas fa-book', title: 'Dados do credenciado', to: {name: 'PageDadosCredenciado'}},
        {icon: 'fas fa-user-md', title: 'Cadastro Profissional', to: {name: 'PageCadastroProfissionalList'}},
        {icon: 'fas fa-file-alt', title: 'Prontuários', to: {name: 'PageProntuario'}},
        {icon: 'fas fa-file-invoice-dollar', title: 'Financeiro', to: {name: 'FinanceiroForm'}},
        {icon: 'fas fa-credit-card', title: 'Dr.Achei Card', to: {name: 'PageValidacaoCartaoSinsaude'}},
        {icon: 'fas fa-ticket-alt', title: 'Voucher DrAchei', to: {name: 'PageValidacaoVoucherDrAchei'}},
        {icon: 'fas fa-user', title: 'Usuário Atendente', to: {name: 'usuarioAtendente'}}
      ],
      menuCredenciadoAgendamento: [
        {icon: 'fas fa-book', title: 'Dados do credenciado', to: {name: 'PageDadosCredenciado'}},
        {icon: 'fas fa-user-md', title: 'Cadastro Profissional', to: {name: 'PageCadastroProfissionalList'}},
        {icon: 'fas fa-calendar', title: 'Agendamentos', to: {name: 'PageAgendamento'}},
        {icon: 'fas fa-file-alt', title: 'Prontuários', to: {name: 'PageProntuario'}},
        {icon: 'fas fa-file-invoice-dollar', title: 'Financeiro', to: {name: 'FinanceiroForm'}},
        {icon: 'fas fa-id-card', title: 'Dr.Achei Card', to: {name: 'PageValidacaoCartaoSinsaude'}},
        {icon: 'fas fa-ticket-alt', title: 'Voucher Dr.Achei', to: {name: 'PageValidacaoVoucherDrAchei'}},
        {icon: 'fas fa-user', title: 'Usuário Atendente', to: {name: 'usuarioAtendente'}}
      ],
      menuAtendenteSemAgendamento: [
        {icon: 'fas fa-file-alt', title: 'Prontuários', to: {name: 'PageProntuario'}},
        {icon: 'fas fa-card', title: 'Dr.Achei Card', to: {name: 'PageValidacaoCartaoSinsaude'}},
        {icon: 'fas fa-ticket-alt', title: 'Voucher Dr.Achei', to: {name: 'PageVaclass="menu-position-top full-screen"lidacaoVoucherDrAchei'}}
      ],
      menuAtendenteAgendamento: [
        {icon: 'fas fa-calendar', title: 'Agendamentos', to: {name: 'PageAgendamento'}},
        {icon: 'fas fa-file-alt', title: 'Prontuários', to: {name: 'PageProntuario'}},
        {icon: 'fas fa-id-card', title: 'Dr.Achei Card', to: {name: 'PageValidacaoCartaoSinsaude'}},
        {icon: 'fas fa-ticket-alt', title: 'Voucher Dr.Achei', to: {name: 'PageValidacaoVoucherDrAchei'}}
      ],
      menuCorpoClinico: [
        {icon: 'fas fa-file-alt', title: 'Prontuários', to: {name: 'PageProntuario'}},
        {icon: 'fas fa-file-alt', title: 'Avaliações', to: {name: 'PageDadosCredenciado'}},
        {icon: 'fas fa-file-alt', title: 'Agendamentos', to: {name: 'PageAgendamento'}},
        {icon: 'fas fa-file-alt', title: 'Meus Dados', to: {name: 'PageProfissionalAutenticado'}}
      ],
      menuPaciente: [
        {icon: 'fas fa-calendar', title: 'Meus Prontuários', to: {name: 'PageDadosCredenciado'}},
        {icon: 'fas fa-calendar', title: 'Meus Agendamentos', to: {name: 'PageAgendamento'}},
        {icon: 'fas fa-calendar', title: 'Avaliações', to: {name: 'PageDadosCredenciado'}},
        {icon: 'fas fa-calendar', title: 'Financeiro', to: {name: 'PageDadosCredenciado'}}
      ]
    }
  },

  methods: {
    openModalUpload () {
      // eventBus.$emit('openModal', 'modalUploadLogo')
    }
  }
}
</script>
